import React from 'react';

import {
  Wrapper,
  Card,
  CardImage,
  CardImageWrapper,
  SuiteDetails,
  CardTitle,
  CardSubtitle,
  Tag,
} from './PaperCard.styles';

export interface PaperCardProps {
  className?: string;
  handleClick?: (e?: React.MouseEvent) => void;
  imageURL: string;
  isFoil?: boolean;
  isLetterpress?: boolean;
  pathname: string;
  styleOverride?: { [key: string]: string };
  title?: string;
  subtitle?: string;
}

const noop = () => {
  /* Do nothing */
};

export const PaperCard = ({
  className,
  handleClick = noop,
  imageURL,
  isFoil,
  isLetterpress,
  pathname,
  styleOverride,
  title,
  subtitle,
}: PaperCardProps): JSX.Element => {
  return (
    <Wrapper className={className} style={{ ...styleOverride }}>
      <Card type="button" onClick={handleClick} href={pathname} aria-label={title}>
        <CardImageWrapper>
          <picture>
            <source srcSet={`${imageURL}?w=${400}`} media="(max-width: 768px)" />
            <source srcSet={`${imageURL}?w=${232}`} media="(max-width: 991px)" />
            <source srcSet={`${imageURL}?w=${448}`} media="(min-width: 992px)" />
            <CardImage src={`${imageURL}?w=350`} alt={title} />
          </picture>
        </CardImageWrapper>

        {/* <FavoriteSuiteToggle
        height={20}
        className={styles.favorite}
        suiteType={card.type}
        suiteUUID={card.suiteUUID}
      /> */}
        <SuiteDetails>
          <CardTitle>
            {title}
            {isFoil && <Tag foil />}
            {isLetterpress && <Tag>LETTERPRESS</Tag>}
          </CardTitle>
          {!!subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
        </SuiteDetails>
      </Card>
    </Wrapper>
  );
};

export default PaperCard;
